import React, { FunctionComponent } from 'react';

import {
  default as MuiTableHead,
  TableHeadProps,
} from '@mui/material/TableHead';

const TableHead: FunctionComponent<TableHeadProps> = (
  props: TableHeadProps
) => {
  return <MuiTableHead {...props}>{props.children}</MuiTableHead>;
};

export default TableHead;
